import React from 'react'
import model_array from '../modules/model_array'
import ObjectList from './ObjectList'

// let component_mounted = false
// const model = 'competitor'
// const model_definition = model_array.find(model_object => model_object.name === model)
// const properties = model_definition.list

const CompetitorList = (props) => {
    return (
        <React.Fragment>
            <h2>Competitors</h2>
            <ObjectList model={'competitor'} />
        </React.Fragment>
    )
}

export default CompetitorList
